let count = 0;

export function useId(id?: string): string {
  return id || `:id:${String(count++)}`;
}
